

export function dropzoneHtml(id:string, message = "Hierher ziehen"){
    const html = '<div id="dropzone-wrapper" class="px-2">' +
    '<form id="' + id + '" class="dropzone dz-clickable ml-4 mr-4 d-flex justify-content-center align-items-center" action="/upload">' +
    '<div class="dz-default dz-message mt-1 mb-1">' +
    '<div class="dz-details"><div class="dz-filename"><span data-dz-name></span></div></div>' + 
    '<button class="btn btn-info btn-circle btn-xl me-1 mb-1 upload-info"' +
    'type="button"><i class="fa fa-upload"></i></button>' +
    '<center>' +
    '<span class="upload-title">' + message + '</span>' +
    '<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>' +
    '<div class="dz-error-message"><span data-dz-errormessage></span></div>' +
    '</center>' +
    '</div>' +
    '</form></div>';
    return html;
}